import * as actionTypes from './../../actionTypes/DataLayer';
import setAndTriggerDataLayer from '../../utils/DataLayer';

const initialState = {
    visitorEmail: '',
    visitorMobile: ''
};

export default function reducer(prevState = initialState, action) {
    let dL;
    switch (action.type) {
        case actionTypes.SET_DATALAYER_EMAIL_MOBILE:
            dL = {
                ...prevState,
                visitorEmail: action.data.result.email || '',
                visitorMobile: action.data.result.telephone || ''
            };
            setAndTriggerDataLayer(dL, false);
            return dL;
        case actionTypes.RESET_DATALAYER_EMAIL_MOBILE:
            dL = {
                ...prevState,
                visitorEmail: '',
                visitorMobile: ''
            };
            setAndTriggerDataLayer(dL, false);
            return dL;
        default:
            return prevState;
    }
}
